import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import SideMenu from "./../dashboard/components/SideMenu";
import Header from "./../dashboard/components/Header";
import AuditList from "./AuditList";
import RightSideMenu from "../dashboard/RIghtSIdeMenu";
import { useAppSelector } from "../../reduxStore/hooks";

export default function Home(props: { disableCustomTheme?: boolean }) {
  const sideMenuOpenLocal = localStorage.getItem("sideMenuToggle");
  const [open, setOpen] = React.useState(
    sideMenuOpenLocal === null ? false : true
  );

  React.useEffect(() => {
    const sideMenuOpenLocal = localStorage.getItem("sideMenuToggle");
    if (sideMenuOpenLocal !== null) {
      setOpen(sideMenuOpenLocal === "true" ? true : false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleDrawer = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  const auditListValue = useAppSelector(
      (state) => state.getAuditListRes
    );
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  
  React.useEffect(() => {
    if(auditListValue?.drawerOpen !== undefined) {
      setIsDrawerOpen(auditListValue.drawerOpen);
    }
  }, [auditListValue?.drawerOpen]);
  return (
    <Box
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "background.paper",
        display: "flex"
      }}
    >
      <Header open={open} toggleDrawer={toggleDrawer} />
      <Box sx={{ display: "flex" }}>
        <SideMenu open={open} />
        {/* Main content */}
        <Box
          component="main"
          sx={(_theme) => ({
            flexGrow: 1,
            overflow: "auto",
          })}
        >
          <Stack
            spacing={1}
            sx={{
              height: "calc(100vh - 80px)",
              mr: 2,
              ml: open ? 0 : 2,
            }}
          >
            <AuditList isDrawerOpen={isDrawerOpen}/>
          </Stack>
        </Box>
        <RightSideMenu isDrawerOpen={isDrawerOpen} />
      </Box>
    </Box>
  );
}
